export const ctaSection = {
  title: "Vous voulez nous rencontrer ?",
  subtitle: "Réservez une visite et découvrez comment nous pouvons accompagner le développement de votre enfant",
  bookVisit: "Réserver une visite"
};
